import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyWebReadyIfNeeded } from 'global/utils/nativeShell';

/**
 * Tells native the destination route has committed and painted.
 * Native keeps Assessments covering until this fires, so Data does not
 * flash when leaving for Photos (same /reports/:display parent).
 */
export default function NativeWebReady() {
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    const id = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!cancelled) notifyWebReadyIfNeeded(pathname);
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(id);
    };
  }, [pathname]);

  return null;
}
